<mat-form-field appearance="fill" class="time-field" [class.time-field--dense]="dense" [subscriptSizing]="dense ? 'dynamic' : 'fixed'" [class.mat-form-field-invalid]="invalid">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input
    matInput
    [value]="text"
    [matAutocomplete]="timeOptionsPanel"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel || label"
    placeholder="h:mm AM"
    autocomplete="off"
    (input)="onInput($any($event.target).value)"
    (keydown.enter)="commit(text)"
    (blur)="onBlur()"
    data-testId="time-field-input">
  <mat-icon matSuffix class="time-field__icon">schedule</mat-icon>
  <mat-autocomplete
    #timeOptionsPanel="matAutocomplete"
    class="time-field__panel"
    (opened)="onOpened()"
    (optionSelected)="commit($event.option.value)"
    (closed)="commit(text)">
    <mat-option *ngFor="let option of options" [value]="option">{{ option }}</mat-option>
  </mat-autocomplete>
  <mat-hint *ngIf="invalid" class="time-field__error">Type a time like 1:03 PM</mat-hint>
</mat-form-field>
